module.exports = __webpack_public_path__ + "img/MapThumb_BigIsland.2deb4203.webp";